import { overviewFacts } from "@/mocks/eventArchive";

export default function OverView() {
  return (
    <section id="jianjie" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>来龙去脉 · 30 秒速览
            </span>
            <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              先把整件事讲清楚
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-foreground-600">
            不掺站队、不预判结论，只按「发生了什么 → 双方怎么说 → 为什么刷屏」三条线，把来龙去脉先立起来。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-12 md:grid-cols-3">
          {overviewFacts.map((f, i) => (
            <article
              key={f.title}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="font-num absolute right-5 top-4 text-4xl leading-none text-foreground-950/8">
                0{i + 1}
              </span>
              <span className="inline-flex w-fit items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                {f.tag}
              </span>
              <h3 className="font-head-cn mt-4 text-xl font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-3 text-sm leading-7 text-foreground-700">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}